import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMProgress } from '../../ui-elements/MyMProgress';

/** MyMine Version2.0 AHSLv2SubLv3画面新規追加
* AHSLv2SubLv3 Page Content
*/
export const AHSLv2SubLv3 = () => {
  const screenId = 'MyM316';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    const endLoading = () => setIsLoading(false);

    apiRequest.requestJson('api/ahs/lv2-3', 'GET', endLoading, endLoading);
  }
    , [])

  if (isLoading)
    return <MyMProgress />

  return (
    <Grid container className='mt-4'>
      <Grid item xs={1} />
      <Grid item xs={10} >
        <Grid container className='mt-4' spacing={2}>
          <Grid item xs={12} md={12} lg={7} >
            <MyMImage
              screenId={screenId}
              filePath={controlSettings.ImageList.imgAhsHistory1}
              alt='AhsHistory1'
              height='auto'
              width='100%'
              display='block'
            />
          </Grid>
          <Grid item xs={12} md={12} lg={5}>
            <MyMImage
              screenId={screenId}
              filePath={controlSettings.ImageList.imgAhsHistory2}
              alt='AhsHistory2'
              height='auto'
              width='100%'
              display='block'
            />
          </Grid>
        </Grid>
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '50px',
          marginTop: '30px'
        }}>
        <MyMImage
          screenId={screenId}
          filePath={controlSettings.ImageList.imgAhsAcheivement}
          alt='AhsAcheivement'
          height='auto'
          width='100%'
          display='block'
        />
        </Box>
      </Grid >
      <Grid item xs={1} />
    </Grid >

  );
}

export default AHSLv2SubLv3;